import React from 'react';
import { useTranslation } from 'react-i18next';

const Blog = () => {
    const { t } = useTranslation();
    return (
        <div className='text-center' style={{ padding: '120px 20px', minHeight: '60vh' }}>
            <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>
                {t('blog.comingSoon')}
            </h1>
            <p style={{ fontSize: '1.25rem', color: '#666' }}>
                {t('blog.message')}
            </p>
        </div>
    );
};

export default Blog;
